import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import { useDebouncedCallback } from 'use-debounce';
import { fg } from '@atlaskit/platform-feature-flags';
import { useDatasourceAnalyticsEvents } from '../../../../../analytics';
import { SpotError } from '../../../../../common/ui/spot/error-state/error';
import { SEARCH_DEBOUNCE_MS } from '../constants';
import { asyncPopupSelectMessages } from './messages';
import CustomSelectMessage from './selectMessage';
var getErrorReasonType = function getErrorReasonType(errors) {
  var _ref = errors || [],
    _ref2 = _slicedToArray(_ref, 1),
    error = _ref2[0];
  if (error instanceof Error) {
    return 'network';
  }
  if (errors && errors.length > 0) {
    return 'agg';
  }
  return 'unknown';
};
var CustomErrorMessage = function CustomErrorMessage(_ref3) {
  var filterName = _ref3.filterName,
    errors = _ref3.errors;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;

  /**
   * Debounce is required because our search is debounced
   * ref: ./noOptionsMessage.tsx
   */
  var _useDebouncedCallback = useDebouncedCallback(function () {
      fireEvent('ui.error.shown.basicSearchDropdown', {
        filterName: filterName,
        reason: getErrorReasonType(errors)
      });
    }, SEARCH_DEBOUNCE_MS),
    _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 1),
    debouncedAnalyticsCallback = _useDebouncedCallback2[0];
  useEffect(debouncedAnalyticsCallback, [debouncedAnalyticsCallback]);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(CustomSelectMessage, {
    icon: /*#__PURE__*/React.createElement(SpotError, {
      size: 'medium',
      alt: formatMessage(asyncPopupSelectMessages.errorMessage)
    }),
    message: fg('platform-linking-visual-refresh-sllv') ? asyncPopupSelectMessages.errorMessage : asyncPopupSelectMessages.errorMessageOld,
    description: fg('platform-linking-visual-refresh-sllv') ? asyncPopupSelectMessages.errorDescription : undefined,
    testId: "".concat(filterName, "--error-message")
  });
};
export default CustomErrorMessage;